var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"myClass"}},[_c('a-tabs',{model:{value:(_vm.activeKey),callback:function ($$v) {_vm.activeKey=$$v},expression:"activeKey"}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"我的课程"}},[_c('LessonPreparationCenterPage')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }